// ————————————————————————————————————————————— DOC. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "api.insertSlides", inline: true, disabled: false };
const msgs = {
  start: ["Lightbox", "API", "insertSlides"],
  end: ["Lightbox", "API", "insertSlides", "API call complete"],
};

// ——————————————————————————————————————— API METHOD DEF. ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function insertSlides(data = { imgSrcs: [] }) {
  //////// Setup /////////
  ////////////////////////

  const { imgSrcs } = data;
  const inst_flkty = this.modules.flkty.instance;
  this.logger("event", msgs.start, "event", logArgs);

  //////// ACTION ////////
  ////////////////////////

  // Clear existing slides
  const existingSlides = inst_flkty.getCellElements();
  existingSlides.forEach((s) => inst_flkty.remove(s));

  // Insert new slides
  imgSrcs.forEach((src) => {
    // Create slide container
    const slideDiv = document.createElement("div");
    slideDiv.setAttribute("g-ref", "slides");
    slideDiv.className = "h-(--h-slide) w-full flex-center";

    // Create image element
    const img = document.createElement("img");
    img.src = src;
    img.className = "h-full w-full object-contain object-center";

    // Append image to slide container
    slideDiv.appendChild(img);

    // Add slide to flickity inst.
    inst_flkty.prepend(slideDiv);

    // Reset inst. to slide index 0
    inst_flkty.select(0, false, true);
  });

  /////// Conclude ///////
  ////////////////////////

  this.logger("success", msgs.end, "success", logArgs);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
